import React from 'react'
import PropTypes from 'prop-types'
import {
  ProductItemContainer,
  ProductName,
  ProductDescription,
  ExtraName,
  ProductInfo,
  Comment,
  ProductPrice,
} from './styled'
import FlexBox from '../../components/FlexBox'
import Icon from '../../components/Icon'
import ItemCounter from '../../components/ItemCounter'
import { formatPrice } from '../../utils/formatter'
import Color from '../../utils/color'

function BasketItem({
  item, onChangeQuantity,
}) {

  function handleChangeQuantity(quantity) {
    onChangeQuantity(item, quantity)
  }

  return (
    <ProductItemContainer key={item.id}>
      <ProductInfo>
        <ProductName>{item.name}</ProductName>
        <ProductDescription>{item.teaser_text}</ProductDescription>
        {(item.extras || []).map(extra => (
          <FlexBox key={extra.extra_id}>
            <Icon name="check" color={Color.Cyan} />
            <ExtraName>{extra.name}</ExtraName>
          </FlexBox>
        ))}
        {item.comment && <Comment>{`※ ${item.comment}`}</Comment>}
        <ItemCounter
          value={item.quantity}
          onChange={handleChangeQuantity}
          max={item.quantity_max}
        />
      </ProductInfo>
      <ProductPrice>{formatPrice(item.price * item.quantity)}</ProductPrice>
    </ProductItemContainer>
  )
}

BasketItem.propTypes = {
  item: PropTypes.object.isRequired,
  onChangeQuantity: PropTypes.func.isRequired,
}

export default BasketItem
